import Translatable from "@/components/translatable_text/Translatable";

function TPPMProtocol() {

  return (
    <section className="py-16 md:py-24 lg:py-32 border-bx border-gray-300">
      <div className="container d-rotate wow">
          <div className="mb-140">
            <h4 className="mb-8 md:mb-12 text-2xl md:text-3xl lg:text-4xl font-semibold">
              <Translatable>At GCAD, excellence in delivery is not accidental — it is governed by a protocol.</Translatable>
            </h4>
          </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 ">
          <div className="lg:col-span-5">
            <h2 className="mb-8 md:mb-12 text-3xl md:text-4xl lg:text-5xl font-bold">
              <Translatable>The Story</Translatable>
            </h2>
          </div>
          <div className="lg:col-span-7">
            <div className="text mb-12 md:mb-16 lg:mb-24 rotate-text">
              <h5 className="text-lg md:text-xl lg:text-2xl font-light leading-relaxed md:leading-loose">
                <Translatable>The Technology Project Protocol Management (TPPM) was created as GCAD’s internal standard for building digital products with consistency, clarity, and accountability. From this protocol, CoreStack and CoreBuild were defined as two integrated execution layers, ensuring that every project follows a disciplined path from vision to production.</Translatable>
              </h5>
            </div>
            {/* style={{ display: 'flex', flexDirection: rtl ? 'row-reverse' : 'row' }} */}
            <div className="accordion borderx border-gray-300 rounded-lg mt-16 md:mt-24 lg:mt-32">
              <div className="item active border-bx border-gray-300 first:rounded-t-lg overflow-hidden">
                <button style={{ display: 'flex'}} className="title w-full px-6 md:px-8 py-4 md:py-6 flex items-center justify-between hover:bg-gray-50 transition-colors rotate-text">
                  <h6 className="text-left text-base md:text-lg font-semibold"><Translatable>CoreStack — The Foundation of Excellence</Translatable></h6>
                  <span className="icox transform transition-transform duration-300 text-lg md:text-xl">+</span>
                </button>
                <div className="accordion-info px-6 md:px-8 py-4 md:py-6 bg-gray-50 rotate-text">
                  <p className="text-gray-700">
                    <Translatable>CoreStack is GCAD’s strategic and architectural foundation phase. Its purpose is to transform ideas into a validated, fully specified product blueprint before any code is written.</Translatable>
                  {/* <br/>
                  <br/> */}
                    <Translatable>It aligns business goals, brand identity, user experience, and system architecture into one coherent plan. Each phase requires formal sign-off, ensuring clarity, feasibility, and risk reduction. By the end of CoreStack, the product is no longer a concept — it is a build-ready system with clear requirements, designs, and technical documentation.</Translatable>
                  </p>
                </div>
              </div>

              <div className="item border-bx border-gray-300 overflow-hidden">
                <button style={{ display: 'flex'}} className="title w-full px-6 md:px-8 py-4 md:py-6 flex items-center justify-between hover:bg-gray-50 transition-colors rotate-text">
                  <h6 className="text-left text-base md:text-lg font-semibold"><Translatable>CoreBuild — From Blueprint to Reality</Translatable></h6>
                  <span className="icox transform transition-transform duration-300 text-lg md:text-xl">+</span>
                </button>
                <div className="accordion-info hidden px-6 md:px-8 py-4 md:py-6 bg-gray-50 rotate-text">
                  <p className="text-gray-700">
                  <Translatable>CoreBuild is the execution engine of TPPM. It transforms the approved CoreStack blueprint into a production-ready digital product through structured engineering, quality assurance, and controlled deployment.</Translatable>
                  <br/>
                  <br/>
                  <Translatable>This phase emphasizes stability, scalability, and accountability. Requirements are frozen, environments are documented, and quality gates are enforced. Development proceeds only with validated inputs, ensuring predictability and delivery confidence.</Translatable>
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="rotate-text img my-20 md:my-40 md:mb-16 lg:mb-20 overflow-hidden rounded-lg md:rounded-xl shadow-lg">
          <img 
            src="https://images.unsplash.com/photo-1617396900799-f4ec2b43c7ae?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
            alt="" 
            className="w-full h-64 md:h-64 lg:h-64 object-cover"
          />
        </div>
      </div>
    </section>
  );
}

export default TPPMProtocol;
